import { State, Action, StateContext, createPropertySelectors } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { IRosterStateModel } from './roster.models';
import { rosterStateDefaults } from './roster.utils';
import { RosterService } from './roster.service';
import { FetchRosterForGame } from './roster.actions';

@Injectable()
@State<IRosterStateModel>({
    name: rosterStateDefaults.sliceName,
    defaults: rosterStateDefaults.defaults
})
export class RosterState {
    public static selectors = createPropertySelectors<IRosterStateModel>(RosterState);

    private _rosterService = inject(RosterService);

    @Action(FetchRosterForGame)
    private _fetchRosterForGame(ctx: StateContext<IRosterStateModel>, { gameId }: FetchRosterForGame) {
        ctx.patchState({
            roster: undefined
        });

        return this._rosterService.getRosterForGame(gameId).pipe(
            map(rosterAndPersons => {
                return ctx.patchState({
                    roster: rosterAndPersons
                });
            })
        );
    }
}
